import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type EffectiveCarrier } from '../domain/Shipment'
import { ShipmentRepository } from '../infra/ShipmentRepository'

export type CreateAssetCarrierParams = {
  shipmentUUID: string
  effectiveCarrier: EffectiveCarrier
}

export type ConfigParams = {
  signal?: AbortSignal
}

export type CreateAssetCarrierFactoryDependencies = {
  repository: ShipmentRepository
}

export function createAssetCarrierFactory({ repository }: CreateAssetCarrierFactoryDependencies) {
  return async function getAgnosticShippersImpl(
    params: CreateAssetCarrierParams,
    config?: ConfigParams
  ) {
    try {
      return await repository.assignAssetCarrierToShipment({ ...params, config })
    } catch (error) {
      const newError = new Error('Failed to assign Asset carrier', { cause: error as Error })
      sentry.log(newError)
      throw newError
    }
  }
}

export function createAssetCarrier(params: CreateAssetCarrierParams, config?: ConfigParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const submit = createAssetCarrierFactory({ repository })

  return submit(params, config)
}
